export default {
      id: "minus-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.792d8a78.svg#minus-usage",
      toString: function () {
        return this.url;
      }
    }